import styled from "@emotion/styled"

const HeroScrollCaseDemoSecondMobileContainer = styled.div`
  position: absolute;
  transform: scale(94%) translateX(84%);
  bottom: -3%;
`

export default HeroScrollCaseDemoSecondMobileContainer
